<template>
  <div class="mod-sys-config">
    <el-row :gutter="16">
      <el-col :span="5" class="config-nav-col">
        <el-card shadow="never" class="group-card">
          <div slot="header">配置模块</div>
          <el-menu :key="menuVersion" mode="vertical" :default-active="groupCode" @select="onGroupSelect">
            <el-menu-item v-for="group in groups" :key="group.groupCode" :index="group.groupCode">{{ group.groupName }}</el-menu-item>
          </el-menu>
        </el-card>
      </el-col>
      <el-col :span="19" class="config-content-col">
        <el-card v-loading="loading" shadow="never">
          <div slot="header" class="panel-header">
            <span>{{ activeGroupName }}</span>
            <el-button v-if="isAuth('sys:config:save')" type="primary" size="small" :loading="saving" @click="save">保存本页</el-button>
          </div>
          <el-empty v-if="!loading && items.length === 0" description="当前模块暂无配置项" />
          <el-form v-else class="config-form" :model="values" label-width="220px">
            <div v-for="section in sections" :key="section.title || 'root'" class="config-section">
              <div v-if="section.title" class="section-title">{{ section.title }}</div>
              <el-form-item v-for="item in section.items" v-show="isItemVisible(item)" :key="item.configCode" :label="item.configName">
                <el-switch v-if="item.valueType === 'bool'" v-model="values[item.configCode]" active-value="1" inactive-value="0" :disabled="isDisabled(item)" />
                <el-select v-else-if="item.valueType === 'enum'" v-model="values[item.configCode]" filterable :disabled="isDisabled(item)" style="width:100%;max-width:420px">
                  <el-option v-for="opt in optionsOf(item)" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
                <el-select v-else-if="item.valueType === 'multi_enum'" :value="multiOf(item)" multiple collapse-tags filterable clearable :disabled="isDisabled(item)" placeholder="请选择" style="width:100%;max-width:420px" @change="val => setMulti(item, val)">
                  <el-option v-for="opt in optionsOf(item)" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
                <el-input-number v-else-if="item.valueType === 'int' || item.valueType === 'decimal'" :value="numberOf(item)" :disabled="isDisabled(item)" :min="constraint(item).min" :max="constraint(item).max" :step="constraint(item).step || (item.valueType === 'int' ? 1 : 0.01)" :precision="item.valueType === 'int' ? 0 : 2" controls-position="right" @change="val => setNumber(item, val)" />
                <el-date-picker v-else-if="item.valueType === 'date'" v-model="values[item.configCode]" type="date" value-format="yyyy-MM-dd" :disabled="isDisabled(item)" placeholder="选择日期" />
                <el-select v-else-if="item.valueType === 'ref' && item.refType === 'finance_subject'" v-model="values[item.configCode]" filterable clearable :disabled="isDisabled(item)" placeholder="选择末级科目" style="width:100%;max-width:420px">
                  <el-option v-for="subject in subjectOptions" :key="subject.financeSubjectId" :label="subjectLabel(subject)" :value="subject.financeSubjectId" />
                </el-select>
                <el-input v-else v-model="values[item.configCode]" :disabled="isDisabled(item)" style="max-width:420px" />
                <div v-if="item.helpText" class="config-help">{{ item.helpText }}</div>
              </el-form-item>
            </div>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'BizConfig',
  data() {
    return {
      groups: [], groupCode: 'inventory', items: [], values: {}, originalValues: {}, menuVersion: 0, permCodes: [],
      loading: false, saving: false, subjectOptions: []
    }
  },
  computed: {
    activeGroupName() {
      const group = this.groups.find(item => item.groupCode === this.groupCode)
      return group ? group.groupName : '业务设置'
    },
    sections() {
      const map = {}
      const order = []
      this.items.forEach(item => {
        const key = item.subgroup || ''
        if (!map[key]) { map[key] = []; order.push(key) }
        map[key].push(item)
      })
      return order.map(title => ({ title, items: map[title] }))
    }
  },
  created() {
    fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    this.loadSubjects()
    request.get('/sys/config/groups').then(res => {
      this.groups = res.data || []
      if (this.groups.length && !this.groups.find(item => item.groupCode === this.groupCode)) {
        this.groupCode = this.groups[0].groupCode
      }
      if (this.groupCode) this.loadItems()
    }).catch(() => {})
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    isDisabled(item) {
      return item.editable !== '1' || !this.isAuth('sys:config:save')
    },
    optionsOf(item) {
      if (!item.optionsJson) return []
      try { return JSON.parse(item.optionsJson) } catch (e) { return [] }
    },
    constraint(item) {
      if (!item.constraintsJson) return {}
      try { return JSON.parse(item.constraintsJson) } catch (e) { return {} }
    },
    multiOf(item) {
      const value = this.values[item.configCode]
      return value ? String(value).split(',').filter(Boolean) : []
    },
    setMulti(item, vals) {
      this.$set(this.values, item.configCode, (vals || []).join(','))
    },
    numberOf(item) {
      const n = parseFloat(this.values[item.configCode])
      return isNaN(n) ? 0 : n
    },
    setNumber(item, val) {
      this.$set(this.values, item.configCode, val == null ? '' : String(val))
    },
    subjectLabel(subject) {
      const code = subject.subjectCode || ''
      const name = subject.subjectName || ''
      return code ? (code + ' ' + name) : name
    },
    isItemVisible(item) {
      const deps = item.deps || item.dependencies || []
      for (let i = 0; i < deps.length; i++) {
        const dep = deps[i]
        if (dep.effect === 'visible' && String(this.values[dep.dependsOn]) !== String(dep.dependsValue)) return false
      }
      return true
    },
    onGroupSelect(code) {
      if (code === this.groupCode) return
      if (this.loading || this.saving) {
        this.menuVersion++
        return
      }
      const switchGroup = () => {
        this.groupCode = code
        this.loadItems()
      }
      const changed = Object.keys(this.values).some(key => String(this.values[key] == null ? '' : this.values[key]) !== String(this.originalValues[key] == null ? '' : this.originalValues[key]))
      if (!changed) {
        switchGroup()
        return
      }
      this.$confirm('当前模块有未保存的修改，切换后将丢失。', '未保存的修改', {
        confirmButtonText: '放弃修改并切换', cancelButtonText: '留在本页', type: 'warning'
      }).then(switchGroup).catch(() => { this.menuVersion++ })
    },
    loadSubjects() {
      request.get('/finance/subject/list').then(res => {
        const rows = res.data || []
        this.subjectOptions = rows.filter(item => String(item.isLeaf) === '1' && String(item.isenabled) !== '1')
      }).catch(() => { this.subjectOptions = [] })
    },
    loadItems() {
      if (!this.groupCode) return
      this.loading = true
      this.items = []
      this.values = {}
      this.originalValues = {}
      request.get('/sys/config/items', { params: { groupCode: this.groupCode } }).then(res => {
        this.items = res.data || []
        const values = {}
        this.items.forEach(item => {
          const current = item.configValue != null ? item.configValue : item.defaultValue
          values[item.configCode] = current == null ? '' : String(current)
        })
        this.values = values
        this.originalValues = { ...values }
      }).catch(() => { this.items = []; this.values = {}; this.originalValues = {} }).finally(() => { this.loading = false })
    },
    save() {
      if (!this.isAuth('sys:config:save')) return
      const payload = {}
      this.items.filter(item => this.isItemVisible(item)).forEach(item => {
        payload[item.configCode] = this.values[item.configCode] == null ? '' : String(this.values[item.configCode])
      })
      this.saving = true
      request.post('/sys/config/save', { groupCode: this.groupCode, values: payload }).then(() => {
        this.$message.success('保存成功')
        this.loadItems()
      }).catch(() => {}).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.group-card { min-height: 480px; }
.group-card >>> .el-menu { border-right: none; width: 100%; }
.panel-header { display: flex; align-items: center; justify-content: space-between; }
.config-section { margin-bottom: 24px; }
.section-title { font-weight: 600; color: #303133; margin: 8px 0 16px; padding-bottom: 8px; border-bottom: 1px solid #ebeef5; }
.config-help { color: #909399; font-size: 12px; line-height: 1.5; margin-top: 4px; }
@media (max-width: 1100px) {
  .config-nav-col, .config-content-col { width: 100%; }
  .config-nav-col { margin-bottom: 12px; }
  .group-card { min-height: 0; }
  .group-card >>> .el-card__header { padding: 10px 14px; }
  .group-card >>> .el-card__body { padding: 0 8px; }
  .group-card >>> .el-menu { display: flex; overflow-x: auto; }
  .group-card >>> .el-menu-item { flex: 0 0 auto; height: 40px; line-height: 40px; padding: 0 12px !important; }
  .config-form >>> .el-form-item__label { float: none; display: block; width: 100% !important; text-align: left; line-height: 22px; }
  .config-form >>> .el-form-item__content { margin-left: 0 !important; width: 100%; }
  .config-form >>> .el-input-number { width: 100%; max-width: 420px; }
}
</style>
